import { IconNameEnum } from "../../../../components/Icon";
import { Tile } from "../../../../components/Tile";
import { getWeighValue } from "../../../../utils/collectionPoints/getWeighValue";
import { Colors } from "../../../../utils/enums";

export interface INumberBannerProps {
  value: number;
  unit?: string;
  label: string;
  doesWeigh?: boolean;
}

export const WeightBanner: React.FC<INumberBannerProps> = ({ label, value, unit, doesWeigh = true }) => {
  return (
    <>
      <Tile
        color={Colors.Border}
        icon={IconNameEnum.weight}
        value={getWeighValue(doesWeigh, value, unit)}
        caption={label}
        valueFontSize="22px"
      />
    </>
  );
};
